import { ReactNode } from 'react';
import { Stack, Typography } from '@common-components';
import { useMount } from 'hooks';
import { getTimezoneLessDisplayDate } from 'utils';
import { LoadingDots } from './LoadingDots';

type AIBubbleItemProps = {
  description: () => ReactNode;
  date?: Date;
  action?: () => Promise<void>;
  isActionExecuted: boolean;
  setIsActionExecuted: (isActionExecuted: boolean) => void;
};

export function AIBubbleItem({ description, date, action, isActionExecuted, setIsActionExecuted }: AIBubbleItemProps) {
  useMount(() => {
    if (!action) {
      setIsActionExecuted(true);
    } else if (!isActionExecuted) {
      action().then(() => {
        setIsActionExecuted(true);
      });
    }
  });

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      borderBottom={1}
      borderColor="divider"
      borderRadius={1}
      padding={1}
      gap={1}
      sx={{
        minHeight: '32px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {action && !isActionExecuted ? (
        <LoadingDots />
      ) : (
        <>
          <Typography variant="body2" component="div">
            {description()}
          </Typography>
          {date && (
            <Typography variant="caption" alignSelf="flex-end">
              {getTimezoneLessDisplayDate(date)}
            </Typography>
          )}
        </>
      )}
    </Stack>
  );
}
